
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-cb5cdc42\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DesignView.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DesignView.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cb5cdc42\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DesignView.vue"),
  /* scopeId */
  "data-v-cb5cdc42",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/components/DesignView.vue
// module id = 223
// module chunks = 1